import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { confidentialityStore } from '../confidentiality.store';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confidentiality-login-dialog.component.html',
})
export class ConfidentialityLoginDialogComponent {
  private readonly store = inject(confidentialityStore);

  login() {
    this.store.triggerLogin();
  }
}
